import { render, staticRenderFns } from "./ItemAdmin.vue?vue&type=template&id=0740f564&scoped=true&"
import script from "./ItemAdmin.vue?vue&type=script&lang=js&"
export * from "./ItemAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ItemAdmin.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ItemAdmin.vue?vue&type=style&index=1&id=0740f564&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0740f564",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VContainer,VDialog,VDivider,VIcon,VRow})
